import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import LandingSection from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';

import './Hero.scss';

const Hero = ({ countryName }) => {
  return (
    <LandingSection containerClassName="hero">
      <div className="hero__content">
        <h1 className="hero__title">
          {trans('countries.hero.title', { country: countryName })}
        </h1>
        <div className="hero__subtitles">
          <p className="hero__subtitle">{trans('countries.hero.subtitle1')}</p>
          <p className="hero__subtitle">{trans('countries.hero.subtitle2')}</p>
        </div>
      </div>
      <div className="hero__image-wrapper">
        <img
          src="https://static.spotahome.com/images/country-landing-hero.svg"
          alt=""
          className="hero__image"
        />
      </div>
    </LandingSection>
  );
};

Hero.propTypes = {
  countryName: PropTypes.string.isRequired
};

export default Hero;
